import { PropertyWizardContext } from 'context/Context';
import { Form, Formik } from 'formik';
import { useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { generateSchema } from '../../validations/characteristics/generateSchema';
import GetCharacteristicsGrid from './utils/GetCharacteristicsGrid';
import { getChangeCarac, getChangeCaracObj } from './utils/getChangeCarac';
import { getInitialValues } from './utils/getInitialValues';
import { CheckErrors } from 'utils/CheckErrors';

const Caracteristicas = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef, form } = useContext(
    PropertyWizardContext
  );

  // Check if there is a decimal value and format it to 2 decimals
  const FormatSurfaces = values => {
    const surfaceFixed = { ...values.surface };

    for (let i in surfaceFixed) {
      if (surfaceFixed[i]) {
        const newSurface = Number(surfaceFixed[i]);
        // Prevents from adding .00 at the end integers
        if (newSurface - Math.trunc(newSurface) > 0) {
          surfaceFixed[i] = Number(newSurface.toFixed(2));
        } else {
          surfaceFixed[i] = newSurface;
        }
      }
    }
    return { ...values, surface: surfaceFixed };
  };

  return form ? (
    <Formik
      initialValues={getInitialValues(form.characteristics, data)}
      validationSchema={generateSchema(form.characteristics, form.propertyType)}
      onSubmit={values => handleSubmit(FormatSurfaces(values))}
    >
      {({ errors, touched, values, setValues }) => {
        const handleChangeCaracObj = getChangeCaracObj(
          setValues,
          setStepStatus
        );

        const handleChangeCarac = getChangeCarac(setValues, setStepStatus);

        useEffect(() => {
          setStepStatus(prev => ({
            ...prev,
            ...values
          }));
        }, [values]);

        return (
          <Form
            onKeyPress={e => {
              e.key === 'Enter' && e.preventDefault();
            }}
          >
            <GetCharacteristicsGrid
              row={form.characteristics}
              errors={errors}
              handleChangeCarac={handleChangeCarac}
              handleChangeCaracObj={handleChangeCaracObj}
              setValues={setValues}
              touched={touched}
              values={values}
              parent
            />

            <button
              onClick={() => CheckErrors(errors)}
              hidden
              ref={yupSubmitRef}
            />
          </Form>
        );
      }}
    </Formik>
  ) : (
    <div className="loading-skeleton">
      <Row className="g-1">
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
        <Col xs={6}>
          <p>asd</p>
        </Col>
      </Row>
    </div>
  );
};

export default Caracteristicas;
